import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import env from "app/utils/env";

const fetchSearchHotels = ({ q, partnerCode, limit }) =>
	axios
		.get(`${env("CACHED_API_URL")}/search-hotels`, { params: { q, limit, partnerCode } })
		.then(res => res.data);

export const useSearchHotels = ({ q = "", partnerCode, limit = 20 }) =>
	useQuery({
		queryKey: ["searchHotels", q, partnerCode, limit],
		queryFn: () => fetchSearchHotels({ q, partnerCode, limit }),
		enabled: Boolean(partnerCode) && q.length > 0,
		staleTime: 1000 * 60 * 5,
	});
